import { render } from "./Picks.vue?vue&type=template&id=1bcb0611"
import script from "./Picks.vue?vue&type=script&lang=js"
export * from "./Picks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__